var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.898,
    height: 45.857,
    viewBox: "0 0 91.898 45.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-mg-white",
    transform: "translate(0 .047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108",
    d: "M537.285 24.293a3.1 3.1 0 0 1-1.743-.536 12.985 12.985 0 1 1 20.234-10.769 3.126 3.126 0 0 1-6.248 0 6.74 6.74 0 1 0-10.5 5.593 3.125 3.125 0 0 1-1.743 5.712z",
    className: "cls-1",
    "data-name": "Trazado 108",
    transform: "translate(-490.344 -.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109",
    d: "M6.993 23.943a3.083 3.083 0 0 1-1.9-.648 12.986 12.986 0 1 1 20.883-10.307 3.13 3.13 0 0 1-6.256 0 6.74 6.74 0 1 0-10.835 5.355 3.125 3.125 0 0 1-1.892 5.6z",
    className: "cls-1",
    "data-name": "Trazado 109",
    transform: "translate(0 -.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110",
    d: "M272.277 24.286a3.126 3.126 0 0 1-1.75-.536 12.987 12.987 0 1 1 20.257-10.761 3.128 3.128 0 1 1-6.256 0 6.736 6.736 0 1 0-10.493 5.585 3.127 3.127 0 0 1-1.758 5.712z",
    className: "cls-1",
    "data-name": "Trazado 110",
    transform: "translate(-245.08 -.043)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_263",
    "data-name": "Grupo 263",
    transform: "translate(39.456 -.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111",
    d: "M537.285 24.293a3.1 3.1 0 0 1-1.743-.536 12.985 12.985 0 1 1 20.234-10.769 3.126 3.126 0 0 1-6.248 0 6.74 6.74 0 1 0-10.5 5.593 3.125 3.125 0 0 1-1.743 5.712z",
    className: "cls-1",
    "data-name": "Trazado 111",
    transform: "translate(-529.8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_112",
    d: "M816.133 22.813a9.93 9.93 0 0 0 .521-.469 12.9 12.9 0 0 0 4.022-9.093 3.127 3.127 0 0 0-6.248-.149 6.734 6.734 0 1 1-6.732-6.9h.238A3.127 3.127 0 0 0 808-.043a12.988 12.988 0 0 0-.618 25.969h.305a6.736 6.736 0 1 1-6.74 6.732 3.126 3.126 0 0 0-6.248 0 12.988 12.988 0 1 0 21.433-9.845z",
    className: "cls-1",
    "data-name": "Trazado 112",
    transform: "translate(-735.516)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_30",
    cx: 2.882,
    cy: 2.882,
    r: 2.882,
    className: "cls-1",
    "data-name": "Elipse 30",
    transform: "translate(86.135 17.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_113",
    d: "M80.146 468.6a5.659 5.659 0 0 1-1.5-.573.593.593 0 0 1-.283-.544.631.631 0 0 1 .179-.447.566.566 0 0 1 .447-.194.742.742 0 0 1 .283.06 5.677 5.677 0 0 0 2.569.588q2.379 0 2.383-2.532v-1.043a3.51 3.51 0 0 1-2.659 1.184 3.758 3.758 0 0 1-3.2-1.825 4.716 4.716 0 0 1-.007-4.439 3.752 3.752 0 0 1 1.422-1.37 3.815 3.815 0 0 1 1.78-.462 3.51 3.51 0 0 1 2.659 1.184v-.387a.715.715 0 0 1 .2-.506.664.664 0 0 1 .5-.208.715.715 0 0 1 .715.715v6.948a4.346 4.346 0 0 1-.946 3.016 3.468 3.468 0 0 1-2.711 1.057 6.806 6.806 0 0 1-1.831-.222zm2.986-5.1a4.5 4.5 0 0 0 1.072-.842v-3.2a4.909 4.909 0 0 0-1.072-.842 2.605 2.605 0 0 0-1.3-.313 2.646 2.646 0 0 0-1.902.697 3.213 3.213 0 0 0 0 4.1 2.891 2.891 0 0 0 3.2.395z",
    className: "cls-1",
    "data-name": "Trazado 113",
    transform: "translate(-72.006 -423.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_114",
    d: "M215.995 464.97a.668.668 0 0 1-.2-.5v-6.68a.715.715 0 0 1 .2-.506.664.664 0 0 1 .5-.209.715.715 0 0 1 .715.715v.67a3.067 3.067 0 0 1 2.443-1.467h.074a.641.641 0 0 1 .492.2.691.691 0 0 1 .194.5.625.625 0 0 1-.2.484.732.732 0 0 1-.514.186h-.074a2.607 2.607 0 0 0-1.37.365 3.2 3.2 0 0 0-1.043 1.005v4.729a.664.664 0 0 1-.209.5.685.685 0 0 1-.506.2.662.662 0 0 1-.502-.192z",
    className: "cls-1",
    "data-name": "Trazado 114",
    transform: "translate(-199.722 -423.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_115",
    d: "M288.084 464.923a3.491 3.491 0 0 1-1.393-1.452 4.958 4.958 0 0 1 0-4.3 3.491 3.491 0 0 1 1.393-1.452 4.518 4.518 0 0 1 4.185 0 3.552 3.552 0 0 1 1.4 1.452 4.891 4.891 0 0 1 0 4.3 3.508 3.508 0 0 1-1.4 1.452 4.518 4.518 0 0 1-4.185 0zm3.322-1.072a2.361 2.361 0 0 0 .961-.931 3.127 3.127 0 0 0 .38-1.616 3.089 3.089 0 0 0-.38-1.6 2.316 2.316 0 0 0-.968-.923 2.78 2.78 0 0 0-1.221-.29 2.743 2.743 0 0 0-1.236.29 2.343 2.343 0 0 0-.961.923 3.661 3.661 0 0 0 0 3.217 2.317 2.317 0 0 0 .961.931 2.727 2.727 0 0 0 1.236.3 2.7 2.7 0 0 0 1.229-.3z",
    className: "cls-1",
    "data-name": "Trazado 115",
    transform: "translate(-264.886 -423.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_116",
    d: "M419.9 465.954a2.717 2.717 0 0 1-.968-1.1 3.55 3.55 0 0 1-.335-1.542v-4.416a.692.692 0 0 1 .209-.5.711.711 0 0 1 1.206.484v4.275c0 1.266.573 1.9 1.713 1.9a2.508 2.508 0 0 0 1.393-.4 5.2 5.2 0 0 0 1.162-1.087v-4.669a.692.692 0 0 1 .208-.5.711.711 0 0 1 1.206.484v6.688a.715.715 0 0 1-.2.506.664.664 0 0 1-.5.209.715.715 0 0 1-.715-.715v-.64a5.044 5.044 0 0 1-1.279 1.038 3.2 3.2 0 0 1-1.616.387 2.686 2.686 0 0 1-1.484-.402z",
    className: "cls-1",
    "data-name": "Trazado 116",
    transform: "translate(-387.422 -424.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_117",
    d: "M547.095 468.543a.685.685 0 0 1-.2-.506v-10.255a.69.69 0 0 1 .678-.7h.022a.715.715 0 0 1 .506.2.664.664 0 0 1 .209.5v.4a3.579 3.579 0 0 1 2.657-1.182 3.643 3.643 0 0 1 1.825.491 3.741 3.741 0 0 1 1.4 1.43 4.8 4.8 0 0 1 0 4.409 3.741 3.741 0 0 1-1.4 1.43 3.663 3.663 0 0 1-1.825.492 3.556 3.556 0 0 1-2.659-1.184v3.969a.691.691 0 0 1-.67.715h-.052a.671.671 0 0 1-.491-.209zm5.526-5.347a3.411 3.411 0 0 0 0-4.141 2.456 2.456 0 0 0-1.854-.73 2.922 2.922 0 0 0-1.348.32 3.736 3.736 0 0 0-1.11.849v3.269a3.862 3.862 0 0 0 1.11.849 2.921 2.921 0 0 0 1.348.32 2.445 2.445 0 0 0 1.854-.737z",
    className: "cls-1",
    "data-name": "Trazado 117",
    transform: "translate(-506.164 -423.009)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMgWhite);
export default __webpack_public_path__ + "static/media/logo-mg-white.75dd9c6542088d8badcb90e01e09f74c.svg";
export { ForwardRef as ReactComponent };